import { target, environment } from '~target'
import { APP_BASE_URL, API_ENDPOINT_URL, APP_DOMAIN } from '~data/constants/app'

//safari extension in-app purchase
let overrideProLink = ''
if (target == 'extension')
    if (environment.includes('safari-ios'))
        overrideProLink = `${API_ENDPOINT_URL}auth/jwt?done_uri=askwise://settings/pro`
    else if (environment.includes('safari'))
        overrideProLink = `${API_ENDPOINT_URL}auth/jwt?done_uri=askwisemacsafari://subscribe`

export default {
    app: {
        index: process.env.NODE_ENV === 'production' ? `https://app.${APP_DOMAIN}` : APP_BASE_URL,
        search: process.env.NODE_ENV === 'production' ? `https://app.${APP_DOMAIN}/my/0/` : `${APP_BASE_URL}/my/0/`,
        import: process.env.NODE_ENV === 'production' ? `https://app.${APP_DOMAIN}/settings/import` : `${APP_BASE_URL}/settings/import`
    },
    
    download: `https://${APP_DOMAIN}/download`,
    blog: `https://blog.${APP_DOMAIN}`,
    better: 'https://askwise.canny.io',
    twitter: 'https://twitter.com/askwise_io',
    translation: 'https://crowdin.com/project/askwise',
    home: `https://${APP_DOMAIN}`,

    help: {
        index: `https://help.${APP_DOMAIN}`,
        about: `https://help.${APP_DOMAIN}/about`,
        'open-multiple-links': `https://help.${APP_DOMAIN}/bookmarks#open-multiple-links-at-once`,
        import: `https://help.${APP_DOMAIN}/import`,
        omnibox: `https://help.${APP_DOMAIN}/browser-extension#search-from-address-bar`,
        'saved-indicator': `https://help.${APP_DOMAIN}/browser-extension/#saved-indicator`,
        'login-problems': `https://help.${APP_DOMAIN}/login-problems`,
        changelog: `https://help.${APP_DOMAIN}/changelog`,
        embed: `https://help.${APP_DOMAIN}/embed`,
        publicPage: `https://help.${APP_DOMAIN}/public-page`,
        collaboration: `https://help.${APP_DOMAIN}/collaboration`,
        'add-bookmark': `https://help.${APP_DOMAIN}/bookmarks#add-new-bookmark`,
        'add-note': `https://help.${APP_DOMAIN}/bookmarks#notes`,
        search: `https://help.${APP_DOMAIN}/using-search`,
        tfa: `https://help.${APP_DOMAIN}/tfa`,
        highlights: {
            index: `https://help.${APP_DOMAIN}/highlights`,
            addExtension: `https://help.${APP_DOMAIN}/highlights/#`+(environment.includes('safari-ios') ? 'add-extension-safari-ios' : 'add-extension')
        },
        backups: {
            automatic: `https://help.${APP_DOMAIN}/backups#automatic`
        },
        troubleshooting: {
            brokenLinks: {
                modes: `https://help.${APP_DOMAIN}/troubleshooting/false-broken-links/#modes`,
            }
        },
        suggestions: {
            index: `https://help.${APP_DOMAIN}/ai-suggestions`,
            organize: `https://help.${APP_DOMAIN}/ai-suggestions#tips`,
            faq: `https://help.${APP_DOMAIN}/ai-suggestions#faq`
        }
    },

    pro: {
        'buy': overrideProLink || `https://${APP_DOMAIN}/pro/buy`,
        'frame': `https://${APP_DOMAIN}/pro?frame=1`,
        'compare': overrideProLink || `https://${APP_DOMAIN}/pro`,
        'faq': `https://help.${APP_DOMAIN}/billing-faq`,
        'help-legacy-subscription': `https://help.${APP_DOMAIN}/article/52-legacy-subscription`,
        'help-change-billing-cycle': `https://help.${APP_DOMAIN}/change-billing-cycle`,
        'help-learn-more': `https://help.${APP_DOMAIN}/premium-features`
    },

    dev: {
        index: `https://developer.${APP_DOMAIN}`,
        terms: `https://developer.${APP_DOMAIN}/terms`,
        token: `https://developer.${APP_DOMAIN}/v1/authentication/token`,
        github:'https://github.com/askwise'
    }
}